<div class="toolbar-container">
	<mat-form-field class="quick-add-field" appearance="outline" subscriptSizing="dynamic">
		<mat-label>Quick Add</mat-label>
		<mat-icon matPrefix>search</mat-icon>
		<input
			#controlsInput
			type="text"
			matInput
			[formControl]="myControl"
			[matAutocomplete]="auto"
			(input)="filter()"
			(focus)="filter()"
		/>
		<mat-autocomplete
			autoActiveFirstOption
			#auto="matAutocomplete"
			[panelWidth]="'300px'"
			(optionSelected)="blockSelected($event)"
			requireSelection
		>
			@for (option of filteredOptions | async; track option) {
				<mat-option [value]="option">{{ option.name }}</mat-option>
			}
		</mat-autocomplete>
	</mat-form-field>

	<!-- Tripetto import (resolved from merge conflict, change if needed) -->
	<button mat-icon-button [matMenuTriggerFor]="menu">
		<mat-icon>more_vert</mat-icon>
	</button>
	<mat-menu #menu="matMenu">
		<button mat-menu-item (click)="importFromTripetto()">Import from Tripetto</button>
	</mat-menu>
</div>
